import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { AuthService } from 'src/app/auth/auth.service';
import { MatChipInputEvent } from '@angular/material/chips';
import { startWith, map } from 'rxjs/operators';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';

@Component({
    selector: 'app-send-emails',
    templateUrl: './send-emails.component.html',
    styleUrls: ['./send-emails.component.scss'],
    standalone: false
})
export class SendEmailsComponent implements OnInit {
  sendEmailForm: FormGroup;
  userID: number;
  namesList: any;

  visible = true;
  selectable = true;
  removable = true;
  separatorKeysNames: number[] = [ENTER, COMMA];
  nameCtrl = new FormControl();
  filteredNames: Observable<string[]>;
  names: any;
  allNames: any;
  nameIds: Array<number>;

  @ViewChild('nameInput') nameInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  invalidNames: boolean;

  constructor(public dialog: MatDialog,
              private dataService: DataService,
              public utils: UtilsService,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<SendEmailsComponent>,
              private authService: AuthService) {
                this.invalidNames = false;
                this.nameIds = new Array<number>();
                this.userID = this.authService.getUserData().id;
                this.namesList = this.data.namesList;
                const namesTemp = [];
                const allNamesTemp = [];
                for (let index = 0; index < this.namesList.length; index++) {
                  const element = this.namesList[index];
                  allNamesTemp.push(element.firstName);
                  namesTemp.push(element.firstName);
                }
                this.names = namesTemp;
                this.allNames = allNamesTemp;
                this.filteredNames = this.nameCtrl.valueChanges.pipe(
                  startWith(null),
                  map((name: string | null) => name ? this._filter(name) : this.allNames.slice()));
              }
  ngOnInit(): void {
    this.sendEmailForm = new FormGroup({
      title: new FormControl(null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      message: new FormControl(null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
    });
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      if (this.names.includes(value.trim())) {
        this.names.push(value.trim());
      }
    }

    if (input) {
      input.value = '';
    }

    this.nameCtrl.setValue(null);

  }

  remove(name: string): void {
    const index = this.names.indexOf(name);

    if (index >= 0) {
      this.names.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (!this.names.includes(event.option.viewValue.trim())) {
      this.names.push(event.option.viewValue);
    }
    this.nameInput.nativeElement.value = '';
    this.nameCtrl.setValue(null);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allNames.filter(name => name.toLowerCase().indexOf(filterValue) === 0);
  }

  closeDialog() {
    if (this.sendEmailForm.dirty) {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Warning',
          type: 'Warn',
          message: 'You will miss your information once you close',
          buttonText: 'cancel',
          numberOfButtons: 2,
          seconButtonText: 'Ok'
        }
      });
      dialogRef.afterClosed().subscribe((status) => {
        if (status === 'Ok') {
          this.dialog.closeAll();
        }
      });
    } else {
      this.dialog.closeAll();
    }
  }

  ngDoCheck() {
    if (this.names.length > 0) {
      this.invalidNames = false;
    } else {
      this.invalidNames = true;
    }
  }

  onSubmit() {
    if (this.names.length > 0) {
    } else {
      this.invalidNames = true;
      return;
    }
    if (this.sendEmailForm.valid) {
      for (let index = 0; index < this.data.namesList.length; index++) {
        const element = this.namesList[index];
        for (let index = 0; index < this.names.length; index++) {
          const item = this.names[index];
          if (item === element.firstName) {
            this.nameIds.push(parseInt(element.id, 10));
          }
        }
      }
      const payload = {
        RecipientsId: this.nameIds,
        Title: this.sendEmailForm.get('title').value,
        Message : this.sendEmailForm.get('message').value,
      };
      this.dataService.post('message/sendMessage', payload).then((data) => {
        if (data.statusCode === 200) {
          this.dialog.closeAll();
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Success',
              type: 'Success',
              message: 'Message has been sent successfully',
              buttonText: 'Ok'
            }
          });
        } else {
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Error',
              type: 'Error',
              message: 'Something went wrong, Please try again!',
              buttonText: 'Ok'
            }
          });
        }
      });
    } else {
      this.sendEmailForm.markAllAsTouched();
    }
  }

}
